var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeWithBackfill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z",
    fill: "#E8F2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z",
    stroke: "#002857",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1968_24838)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1968_24838",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 18,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 9H9V27H27V9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1968_24838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9975 21.2489C16.205 21.2489 14.75 19.7939 14.75 18.0014C14.75 16.2089 16.205 14.7539 17.9975 14.7539C19.79 14.7539 21.245 16.2089 21.245 18.0014C21.245 19.7939 19.79 21.2489 17.9975 21.2489ZM17.9975 15.8789C16.8275 15.8789 15.875 16.8314 15.875 18.0014C15.875 19.1714 16.8275 20.1239 17.9975 20.1239C19.1675 20.1239 20.12 19.1714 20.12 18.0014C20.12 16.8314 19.1675 15.8789 17.9975 15.8789Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9986 24.7663C15.1786 24.7663 12.5161 23.1164 10.6861 20.2514C9.89109 19.0139 9.89109 16.9964 10.6861 15.7513C12.5236 12.8863 15.1861 11.2363 17.9986 11.2363C20.8111 11.2363 23.4736 12.8863 25.3036 15.7513C26.0986 16.9889 26.0986 19.0064 25.3036 20.2514C23.4736 23.1164 20.8111 24.7663 17.9986 24.7663ZM17.9986 12.3613C15.5761 12.3613 13.2586 13.8163 11.6386 16.3588C11.0761 17.2364 11.0761 18.7664 11.6386 19.6439C13.2586 22.1864 15.5761 23.6413 17.9986 23.6413C20.4211 23.6413 22.7386 22.1864 24.3586 19.6439C24.9211 18.7664 24.9211 17.2364 24.3586 16.3588C22.7386 13.8163 20.4211 12.3613 17.9986 12.3613Z",
    fill: "#002857"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1968_24838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeWithBackfill);
export default __webpack_public_path__ + "static/media/eyeWithBackfill.99e0d0350c027f079fd2655f9cf2587e.svg";
export { ForwardRef as ReactComponent };